import { makeVar } from "@apollo/client";
import { NotificationObject } from "./types";

const notificationsVar = makeVar<Array<NotificationObject>>([]);

export default notificationsVar;
